import { AxiosResponse } from "axios";
import { Routes } from "../Routes";

import BaseCrudService from "../BaseCrudService";
import User, { Profile, UserPasswordChangeVO, UserPerson, UserWithProfile } from "./SecuyrityEntities";

export default class SecurityService extends BaseCrudService<User> {
    getBasePath(): string {
        return "user";
    }
    getSearchRoute(): string {
        return Routes.USERS;
    }
    getEditRoute(): string {
        return Routes.USER;
    }

    constructor() {
        super();
    }

    static get PERFIL_MARKETING() {
        return "Marketing Digital";
    }

    static get PERFIL_ALUNO() {
        return "Aluno";
    }

    static get PERFIL_INSTRUTOR() {
        return "Instructor";
    }

    static get PERFIL_ADM() {
        return "Administrator";
    }

    async loggedUser(): Promise<UserWithProfile> {
        const res = await this.http.get("loggedUser");
        return this.handleRespose(res);
    }

    async listarUsuariosAtivos() {
        const res = await this.http.get(this.getBasePath());
        return this.handleRespose(res);
    }

    async listProfiles() {
        const res = await this.http.get(`security/profile`);
        return this.handleRespose(res);
    }

    async listMyPermissions(): Promise<Profile[]> {
        const res = await this.http.get(`${this.getBasePath()}/my/profile`);
        return this.handleRespose(res);
    }

    async listUserPermissions(username: string): Promise<Profile[]> {
        const res = await this.http.get(`${this.getBasePath()}/${username}/profile`);
        return this.handleRespose(res);
    }

    async logar(usuario: User): Promise<any> {
        try {
            const res = await this.http.post(`login`, usuario, {
                withCredentials: true,
                headers: { "Access-Control-Allow-Origin": "*" },
            });
            return res;
        } catch (err) {
            console.log("Deu erro ao logar: " + err);

            throw err;
        }
    }

    async logout() {
        const res = await this.http.post(`logout`, {}, { withCredentials: true, headers: { "Access-Control-Allow-Origin": "*" } });
        if (res && res.status >= 200 && res.status < 300) {
            return res;
        }
    }

    async listaUsuarios() {
        const res = await this.http.get("usuario/all");
        return this.handleRespose(res);
    }

    async obterUsuario(username: string): Promise<any> {
        const res = await this.http.get(`${this.getBasePath()}/${username}`);
        return this.handleRespose(res);
    }

    async obterUsuarioPorUserName(username: string) {
        const res = await this.http.get(`${this.getBasePath()}/${username}`);
        return this.handleRespose(res);
    }

    async obterUserPersonId(pessoaId: number) {
        const res = await this.http.get(`${this.getBasePath()}/person/${pessoaId}`);
        return this.handleRespose(res);
    }

    async updateUserPermissions(userId: number, perfis: Profile[]) {
        const res = await this.http.post(`/${this.getBasePath()}/${userId}/profile`, perfis);
        return this.handleRespose(res);
    }

    async inserirUsuario(usuario: UserPerson) {
        const res = await this.http.post(this.getBasePath(), usuario);
        return this.handleRespose(res);
    }

    async insertMyUser(usuario: User) {
        const res = await this.http.post(`${this.getBasePath()}/my`, usuario);
        return this.handleRespose(res);
    }
    async updateMyUser(usuario: User): Promise<User> {
        const res = await this.http.put(`${this.getBasePath()}/my`, usuario);
        return this.handleRespose(res);
    }

    async criarMinhaSenha() {
        const res = await this.http.get(`/security/password`);
        return this.handleRespose(res);
    }

    async changeMyPassword(usuVo: UserPasswordChangeVO): Promise<any> {
        const res = await this.http.post(`/security/user/changeMyPassword`, usuVo);
        return this.handleRespose(res);
    }

    async associarChatTelegram(telegramCodigoAssociacao: string) {
        const res = await this.http.post(`/security/bot/associar`, {
            telegramCodigoAssociacao: telegramCodigoAssociacao,
        });
        return this.handleRespose(res);
    }

    async updateUser(usuario: UserPerson) {
        const res = await this.http.put(`${this.getBasePath()}`, usuario);
        return this.handleRespose(res);
    }

    async obterMeusDados(): Promise<UserPerson> {
        const res = await this.http.get(`${this.getBasePath()}/meusDados`);
        return this.handleRespose(res);
    }

    async generateToken(userId: number): Promise<string> {
        return await this.http.post(`${this.getBasePath()}/${userId}/token`).then((res: AxiosResponse) => {
            return this.handleRespose(res);
        });
    }

    async checkOauthGoogleToken(token: String): Promise<string> {
        // /user/oauth/check/google
        const res: AxiosResponse = await this.http.post(`/user/oauth/check/google`, token, {
            headers: {
                "Content-Type": "text/plain",
            },
        });
        return this.handleRespose(res);
    }
}
